<template>
  <main>
    <slot name="content"></slot>
  </main>
</template>

<script>
import Vue from 'vue'
import VueConfetti from 'vue-confetti'

Vue.use(VueConfetti)

export default {
  mounted() {
    this.confetti()
  },

  methods: {
    confetti () {
      this.$confetti.start({
        particlesPerFrame: 1,
        particles: [
          {
            type: 'rect',
            size: 10,
            dropRate: 15,
          },
        ],
        defaultColors: [
          '#e2304d',
          '#00539f',
          '#ba0000'
        ],
      })

      setTimeout(() => {
        this.$confetti.stop()
      }, 2000)
    }
  }
}
</script>
